export default "__VITE_ASSET__BdBJKalX__"